export const gatewaysData = {
  saman: { logo: "saman.png", title: "بانک سامان" },
  sadad: { logo: "sadad.png", title: "بانک ملی" },
  parsian: { logo: "parsian.png", title: "بانک پارسیان" },
  sepah: { logo: "sepah.png", title: "بانک سپه" },
  irankish: { logo: "irankish.png", title: "ایران کیش" },
  mellat: { logo: "behpardakht.png", title: "به پرداخت ملت" },
}
